import {https , httpsFile} from './http.js';
export function index(){
    return https().get(`/users`);
}

export function datatable(page,currentpage, search){
    return https().get(`/users-table?page=${page}&currentpage=${currentpage}&search=${search}`);
}
export function showUserSupplier(page,currentpage, search){
    return https().get(`/showUserSupplier?page=${page}&currentpage=${currentpage}&search=${search}`);
}
export function showUserApprovers(page,currentpage, search){
    return https().get(`/showUserApprovers?page=${page}&currentpage=${currentpage}&search=${search}`);
}

export function store(data){
    return https().post(`/users`,data);
}

export function show(id){
    return https().get(`/users/${id}/edit`);
}

export function getAssignedUserApprover(){
    return https().get(`/getAssignedUserApprover`);
}

export function update(id,data){
    return https().post(`/users/${id}`,data);
}
export function assignSupplier(data){
    return https().post(`/assignSupplier`,data);
}

export function assignUserApprover(data){
    return https().post(`/assignUserApprover`,data);
}

export function changePassword(id){
    return https().post(`/change-password/${id}`);
}

export function destroy(id){
    return https().delete(`/users/${id}`);
}

export function updateProfile(id,data){
    return https().post(`/update-profile/${id}`,data);
}